import { MutationTree } from "vuex";
import { PaymentState } from "./types";

export const mutations: MutationTree<PaymentState> = {};
